import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Account } from 'src/app/models/account.model';
import { AccountsService } from 'src/app/services/accounts.service';
import * as globals from '../../globals';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-accounts-list',
  templateUrl: './accounts-list.component.html',
  styleUrls: ['./accounts-list.component.scss']
})
export class AccountsListComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    private accountsService: AccountsService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.getAccounts();
    this.isContributor = ([`${globals.TC}:${globals.trainingadmin}`, `${globals.TC}:${globals.trainer}`].includes(localStorage.getItem(globals.POLICIES)));    
  }

  private updateAccount(account: Account)
  {
    this.account = account;
    this.sidenavassign.open();
  }

  private getAccounts() {
    try {
      this.loadingSpinner(true);
      this.accountsService.getAccountsAll().subscribe({
        next: (data) => {
          this.dataSource = new MatTableDataSource(data);
          this.logger.logEvent('Accounts Loaded', { count: data?.length });
          this.loadingSpinner(false);
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner(false);
        }
      });
    }
    catch {}
  }

  addedAccount = (response) => this.refresh();

  cancelledAccount = (response) => this.refresh();

  private refresh = () => {
    this.account = new Account();
    this.getAccounts();
  };

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  loadingSpinner = (value: boolean) => this.isLoading = value;

  isContributor: boolean;
  isLoading: boolean;
  account: Account = new Account();
  dataSource = new MatTableDataSource<Account>();
  secretVisibility = new Map<number, boolean>();
  displayedColumns: string[] = globals.accounts_columns;
  
  @ViewChild('sidenavaccount') sidenavassign: MatSidenav;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

}
